export const MONITORING_DEFAULT_RANGE_MONTHS = 12;
